export interface TokenManager {
  logger: {
    log: (...args: any[]) => void;
    warn: (...args: any[]) => void;
    error: (...args: any[]) => void;
    debug: (...args: any[]) => void;
    info: (...args: any[]) => void;
    logWSEvent: (...args: any[]) => void;
    logWSError: (...args: any[]) => void;
    logUserAction: (action: string, data?: any) => void;
  };
  showNotification: (options: {
    message: string;
    severity?: 'success' | 'info' | 'warning' | 'error';
    duration?: number;
    playSound?: boolean;
  }) => void;
  getUserTokens: () => { accessToken?: string; refreshToken?: string };
  setUserTokens: (tokens: {
    accessToken: string;
    refreshToken: string;
  }) => void;
  removeUserTokens: () => void;
  getCustomerTokens: (businessId: string) => {
    accessToken?: string;
    refreshToken?: string;
  };
  setCustomerTokens: (
    businessId: string,
    tokens: { accessToken: string; refreshToken: string }
  ) => void;
  removeCustomerTokens: (businessId: string) => void;
  getBusinessId: () => string | null;
  setBusinessId: (id: string) => void;
  onAuthError: () => void;
  getDeviceId?: () => Promise<string | undefined>;
}

let _manager: TokenManager = {
  logger: {
    log: console.log,
    warn: console.warn,
    error: console.error,
    debug: console.debug,
    info: console.info,
    logWSEvent: console.log,
    logWSError: console.error,
    logUserAction: () => {
      return;
    },
  },
  showNotification: (opts) => console.log('Notification:', opts.message),
  getUserTokens: () => ({}),
  setUserTokens: () => {},
  removeUserTokens: () => {},
  getCustomerTokens: () => ({}),
  setCustomerTokens: () => {},
  removeCustomerTokens: () => {},
  getBusinessId: () => null,
  setBusinessId: () => {},
  onAuthError: () => {
    console.warn('Auth Error - unhandled reload');
  },
};

export const setTokenManager = (manager: TokenManager) => {
  _manager = manager;
};

export const getTokenManager = () => _manager;
